export default (state = "en-US", action) => {

    switch(action.type) {
        case 'LOCALIZATION_SET_REQUEST':
            return action.payload;

        case 'LOCALIZATION_SET_SUCCESS':
            return action.payload;

        case 'LOCALIZATION_SET_FAILURE':
            return state;

        default:
            return state;
    }

}